/**
 * Распаковать наш zip расширения в памяти.
 *
 * Формат тот же, что пишет `scripts/pack-ext.mjs`: deflate-raw, без data
 * descriptor. Чужой метод и путь с `..` — отказ, не запись мимо папки.
 */

const LOCAL = 0x04034b50;
const MAX_FILE = 4_000_000;
const MAX_TOTAL = 8_000_000;

export async function inflateRaw(data: Uint8Array): Promise<Uint8Array> {
  if (typeof DecompressionStream !== 'function') {
    throw new Error('браузер не умеет распаковать архив');
  }
  const copy = Uint8Array.from(data);
  const input = new ReadableStream({
    start(controller) {
      controller.enqueue(copy);
      controller.close();
    },
  });
  const out = input.pipeThrough(new DecompressionStream('deflate-raw') as never);
  const buf = await new Response(out as ReadableStream).arrayBuffer();
  return new Uint8Array(buf);
}

function readName(buf: ArrayBuffer, start: number, len: number): string {
  return new TextDecoder().decode(new Uint8Array(buf, start, len));
}

export async function unzip(buf: ArrayBuffer): Promise<Map<string, Uint8Array>> {
  const view = new DataView(buf);
  const out = new Map<string, Uint8Array>();
  let offset = 0;
  let total = 0;
  while (offset + 30 <= buf.byteLength) {
    if (view.getUint32(offset, true) !== LOCAL) break;
    const method = view.getUint16(offset + 8, true);
    const packed = view.getUint32(offset + 18, true);
    const raw = view.getUint32(offset + 22, true);
    const nameLen = view.getUint16(offset + 26, true);
    const extra = view.getUint16(offset + 28, true);
    const nameAt = offset + 30;
    const name = readName(buf, nameAt, nameLen);
    if (name.includes('..') || name.startsWith('/') || name.includes('\\')) {
      throw new Error('в архиве чужой путь');
    }
    const dataAt = nameAt + nameLen + extra;
    if (dataAt + packed > buf.byteLength) throw new Error('архив обрезан');
    if (raw > MAX_FILE || total + raw > MAX_TOTAL) throw new Error('архив слишком большой');
    const slice = new Uint8Array(buf, dataAt, packed);
    let body: Uint8Array;
    if (name.endsWith('/')) {
      offset = dataAt + packed;
      continue;
    }
    if (method === 0) body = slice.slice();
    else if (method === 8) body = await inflateRaw(slice);
    else throw new Error('неизвестный метод сжатия');
    out.set(name, body);
    total += body.byteLength;
    offset = dataAt + packed;
  }
  if (out.size === 0) throw new Error('архив пуст');
  return out;
}
